import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

function isValidDateInput(value: any): boolean {
  if (value == null || value === '') return false;
  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }
  if (typeof value === 'number') {
    return !isNaN(value);
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '-' || trimmed === 'N/A') return false;
    if (/^\d+$/.test(trimmed)) {
      return !isNaN(new Date(Number(trimmed)).getTime());
    }
    const parsed = Date.parse(trimmed);
    return !isNaN(parsed);
  }
  return false;
}

@Pipe({
    name: 'customTime',
    standalone: false
})
export class CustomTimeFormatPipe extends DatePipe implements PipeTransform {
	transform(value: any, args?: any): any {
		if (!value) return '';
		if (!isValidDateInput(value)) return value;
		try {
			return super.transform(value, 'hh:mm a');
		} catch {
			return value;
		}
	}
}